import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import BrandLogo from './BrandLogo';
import { registerLocalIndicator } from '../utils/dataLoading';
const logoLetters = [
    ['0%', '21%', '0s'],
    ['21%', '36%', '0.16s'],
    ['36%', '52%', '0.32s'],
    ['52%', '67%', '0.48s'],
    ['67%', '82%', '0.64s'],
    ['82%', '95%', '0.8s'],
    ['95%', '100%', '0.96s'],
]

const ManagdPageLoader = ({ visible, message = 'Loading…', globalIndicator = false }) => {
    useEffect(() => {
        if (visible && !globalIndicator) return registerLocalIndicator()
    }, [visible, globalIndicator])
    if (!visible) return null

    return createPortal(
        <div className='managdPageLoader' role='status' aria-live='polite' aria-label={message}>
            <div className='managdPageLoaderContent'>
                <div className='managdPageLoaderLogoStage' aria-hidden='true'>
                    {logoLetters.map(([start, end, delay], index) => (
                        <span
                            className='managdPageLoaderLetter'
                            key={index}
                            style={{ '--letter-start': start, '--letter-end': end, '--letter-delay': delay }}
                        >
                            <BrandLogo height={58} />
                        </span>
                    ))}
                </div>
                <div className='managdPageLoaderUnderline' aria-hidden='true'><span /></div>
                <p>{message}</p>
            </div>
        </div>,
        document.body
    )
}

export default ManagdPageLoader
